import React from 'react';

const ArrowDown = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.12504 6.83337L7.03241 6.83892C6.83984 6.8616 6.66229 6.95418 6.53344 7.09908C6.40459 7.24398 6.3334 7.43114 6.33337 7.62504V9.20758L4.28612 9.20837C3.97302 9.20844 3.66696 9.30134 3.40664 9.47532C3.14633 9.6493 2.94344 9.89656 2.82363 10.1858C2.70382 10.4751 2.67247 10.7934 2.73353 11.1005C2.7946 11.4076 2.94534 11.6897 3.1667 11.9111L8.38062 17.125C8.67754 17.4219 9.08019 17.5886 9.50004 17.5886C9.91988 17.5886 10.3225 17.4219 10.6195 17.125L15.8334 11.9111C16.0549 11.6897 16.2058 11.4075 16.267 11.1003C16.3282 10.7931 16.2968 10.4747 16.177 10.1853L16.1231 10.0705C15.9903 9.81101 15.7885 9.59321 15.5399 9.44109C15.2912 9.28897 15.0054 9.20844 14.714 9.20837L12.6667 9.20758V7.62504C12.6667 7.41508 12.5833 7.21371 12.4348 7.06525C12.2864 6.91678 12.085 6.83337 11.875 6.83337H7.12504Z",
      fill: "#FFE248"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.875 2.08337C12.0768 2.0836 12.2709 2.16086 12.4176 2.29938C12.5643 2.4379 12.6526 2.62721 12.6645 2.82864C12.6763 3.03008 12.6107 3.22842 12.4812 3.38316C12.3517 3.53789 12.168 3.63733 11.9677 3.66117L11.875 3.66671H7.12503C6.92325 3.66648 6.72917 3.58922 6.58244 3.4507C6.43572 3.31219 6.34743 3.12287 6.3356 2.92144C6.32377 2.72 6.38931 2.52166 6.51882 2.36692C6.64833 2.21219 6.83204 2.11275 7.0324 2.08892L7.12503 2.08337H11.875Z",
      fill: "#FFE248"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.875 4.45837C12.0768 4.4586 12.2709 4.53586 12.4176 4.67438C12.5643 4.8129 12.6526 5.00221 12.6645 5.20364C12.6763 5.40508 12.6107 5.60342 12.4812 5.75816C12.3517 5.91289 12.168 6.01233 11.9677 6.03617L11.875 6.04171H7.12503C6.92325 6.04148 6.72917 5.96422 6.58244 5.8257C6.43572 5.68719 6.34743 5.49787 6.3356 5.29644C6.32377 5.095 6.38931 4.89666 6.51882 4.74192C6.64833 4.58719 6.83204 4.48775 7.0324 4.46392L7.12503 4.45837H11.875Z",
      fill: "#FFE248"
    }
  )
);
ArrowDown.displayName = "Icons.ArrowDown";

export { ArrowDown };
//# sourceMappingURL=ArrowDown.js.map
